import { Quote, X } from 'lucide-react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { RolePageData } from '../../types'

interface ConvincersSectionProps {
  data: RolePageData
}

export const ConvincersSection = ({ data }: ConvincersSectionProps) => {
  return (
    <section className="w-full py-24 bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <Column className="w-full max-w-6xl mx-auto px-8 gap-16">
        {/* Convincers */}
        <Column className="gap-12">
          <Column className="gap-4 text-center">
            <h2 className="text-3xl font-normal text-slate-800">
              What makes us different
            </h2>
            <p className="text-slate-500 text-lg max-w-xl mx-auto">
              The promises we make to every {data.label.toLowerCase()} we work with.
            </p>
          </Column>

          <div className="grid grid-cols-2 gap-6">
            {data.convincers.map((convincer) => (
              <Card
                key={convincer.quote}
                className="p-6 rounded-2xl bg-white/70 backdrop-blur-sm border border-white/60"
              >
                <Column className="gap-4">
                  <Row className="items-start gap-3">
                    <Quote className="w-6 h-6 text-slate-400 flex-shrink-0" />
                    <h3 className="text-lg font-medium text-slate-800">
                      {convincer.quote}
                    </h3>
                  </Row>
                  <p className="text-slate-500 text-sm leading-relaxed pl-9">
                    {convincer.description}
                  </p>
                </Column>
              </Card>
            ))}
          </div>
        </Column>

        {/* Deal breakers */}
        <Column className="gap-8 p-8 bg-stone-50 rounded-2xl">
          <Column className="gap-2 text-center">
            <h3 className="text-xl font-medium text-slate-800">
              What we'll never do
            </h3>
            <p className="text-slate-500">
              We've seen what doesn't work. Here's what we avoid.
            </p>
          </Column>

          <Row className="gap-6 justify-center">
            {data.dealBreakers.map((breaker) => (
              <Row
                key={breaker.title}
                className="items-start gap-3 flex-1 max-w-xs"
              >
                <div className="w-8 h-8 rounded-full bg-slate-100/80 flex items-center justify-center flex-shrink-0">
                  <X className="w-4 h-4 text-red-500" />
                </div>
                <Column className="gap-1">
                  <p className="font-medium text-slate-800">{breaker.title}</p>
                  <p className="text-sm text-slate-500">{breaker.description}</p>
                </Column>
              </Row>
            ))}
          </Row>
        </Column>
      </Column>
    </section>
  )
}
